import { Messages } from '~src/codegen/Localize';
import { ToasterService, ToastType } from '~src/commonInfra/services/ToasterService';
import { WebHttpClientWithErrorToastInstance } from '~src/httpClient/WebHttpClientWithErrorToast';
import { IUser } from '~src/userManagement/users/serverApi/types/IUser';
import { IUserActionResult } from '~src/userManagement/users/serverApi/types/IUserActionResult';

import {
  CreateActiveDirectoryIdentityForServerUserRequest,
  CreateActiveDirectoryIdentityForSiteUserRequest,
  CreateActiveDirectoryIdentityForUserParams
} from '../components/identityPools/requests/CreateActiveDirectoryIdentityForUserRequest';
import {
  CreateLocalIdentityForServerUserRequest,
  CreateLocalIdentityForSiteUserRequest,
  CreateLocalIdentityForUserParams
} from '../components/identityPools/requests/CreateLocalIdentityForUserRequest';
import { SearchActiveDirectoryUserNameRequest } from '../components/identityPools/requests/SearchActiveDirectoryUserNameRequest';

export namespace CreateUserIdentityService {

  export function createLocalIdentityForUser(user: IUser, identityPoolName: string, identifier: string, isServerUser: boolean): Promise<IUserActionResult> {
    const requestParams: CreateLocalIdentityForUserParams = {
      id: user.id,
      identityPoolName: identityPoolName,
      identifier: identifier
    };

    const successfulMessage = Messages.identityPools_AddToPoolAction_SuccessfullyAddUserToPool({
      USER_DISPLAY_NAME: user.displayName,
      IDENTITY_POOL_NAME: identityPoolName == null ? Messages.identityPools_DefaultIdentityPoolName() : identityPoolName
    });

    if (isServerUser) {
      return WebHttpClientWithErrorToastInstance.sendRequestAndDelay(new CreateLocalIdentityForServerUserRequest(requestParams))
        .then((result) => {
          ToasterService.instance.pop({ type: ToastType.Success, text: successfulMessage });
          return result;
        });
    }

    return WebHttpClientWithErrorToastInstance.sendRequestAndDelay(new CreateLocalIdentityForSiteUserRequest(requestParams))
      .then((result) => {
        ToasterService.instance.pop({ type: ToastType.Success, text: successfulMessage });
        return result;
      });
  }

  export function createActiveDirectoryIdentityForUser(user: IUser, identityPoolName: string, username: string, isServerUser: boolean) {
    const requestParams: CreateActiveDirectoryIdentityForUserParams = {
      id: user.id,
      identityPoolName: identityPoolName,
      username: username
    };

    const successfulMessage = Messages.identityPools_AddToPoolAction_SuccessfullyAddUserToPool({
      USER_DISPLAY_NAME: user.displayName,
      IDENTITY_POOL_NAME: identityPoolName == null ? Messages.identityPools_DefaultIdentityPoolName() : identityPoolName
    });

    if (isServerUser) {
      return WebHttpClientWithErrorToastInstance.sendRequestAndDelay(new CreateActiveDirectoryIdentityForServerUserRequest(requestParams))
        .then((result) => {
          ToasterService.instance.pop({ type: ToastType.Success, text: successfulMessage });
          return result;
        });
    }

    return WebHttpClientWithErrorToastInstance.sendRequestAndDelay(new CreateActiveDirectoryIdentityForSiteUserRequest(requestParams))
      .then((result) => {
        ToasterService.instance.pop({ type: ToastType.Success, text: successfulMessage });
        return result;
      });
  }

  export function searchActiveDirectoryUserName(searchInputText: string): Promise<any> {
    return WebHttpClientWithErrorToastInstance.sendRequest(new SearchActiveDirectoryUserNameRequest({ name: searchInputText }));
  }
}
